import React, { useEffect, useRef, useState } from "react"
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardImg,
  CardText,
  CardTitle,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
} from "reactstrap"
import Breadcrumb from "../../components/Common/Breadcrumb"
import { FaCirclePlus } from "react-icons/fa6"
import AppListModal from "../../additional_components/common/Modals/AppListModal"
import { Link } from "react-router-dom"
import classnames from "classnames"
import ComparisonTabs from "../AppTracking/comparisonTabs"
import { api} from "../../utils/variables"
import axios from "axios"
import FeatureTabs from "./featureTabs"
import AppSearchModal from "../../additional_components/common/Modals/AppSearchModal"
import metalogo from "../../../src/assets/images/meta-logo.png"
import KeywordDataTable from "../../additional_components/marketResearch/keywordTracking/KeywordDataTable"
import GetCSVModal from "../../additional_components/common/Modals/GetCSVModal"
import Loader from "../../additional_components/common/Modals/Loader"
import CollapsibleTrackedWords from "./CollapsibleTrackedWords"
import DataGraphTable from "../../additional_components/marketResearch/keywordTracking/DataGraphTable"
import flags, { countryNames } from "../../common/flag"
import { Select } from "@material-ui/core"
import SEO from "../../components/Common/SEO"
import { generateSlug } from "../../utils/seoUtils"


export default function KeywordTracking() {
  // const [activeTab1, setactiveTab1] = useState("5")

  const [inputValue, setInputValue] = useState("")
  const [modal_toggle, setmodal_toggle] = useState(false)
  const [csvModal_toggle, setcsvModal_toggle] = useState(false)

  const [trackedKeyword, setTrackedKeyword] = useState([])

  const [selectedApp, setSelectedApp] = useState(null)
  const [selectedApp1, setSelectedApp1] = useState(null)
  const [selectedAppBasic, setSelectedAppBasic] = useState(null)
  // const [selectedApp2, setSelectedApp2] = useState(null)
  // const [selectedApp3, setSelectedApp3] = useState(null)

  const [alreadyTrackedApps, setAlreadyTrackedApps] = useState([])

  const [loading, setLoading] = useState(false)
  const [sectionLoading, setSectionLoading] = useState(false)
  const [keywordLoading, setKeywordLoading] = useState(false)
  const [dataLoader, setDataLoader] = useState(false)
  // const [csvLoader, setCsvLoader] = useState(false)
  const [switchTable, setSwitchTable] = useState(false)

  const [predefKeyword, setpredef] = useState([])
  const [trackedKeywordData, setTrackedKeywordData] = useState({})
  const [trackedKeyword2, setTrackedKeyword2] = useState({})
  const [selectedCountryCode, setSelectedCountryCode] = useState("")
  const [selectedLanguage, setSelectedLanguage] = useState("")
  const [languages, setLanguages] = useState([])
  const [countries, setCountries] = useState([])
  const [showValidation, setShowValidation] = useState(false)

  // const [storedgameAppData, setStoredgameAppData] = useState(
  //   sessionStorage.getItem("firstAppKeyword")
  // )

  const [activeTab, setactiveTab] = useState("1")

  const [isAddDisabled, setIsAddDisabled] = useState(false)
  const pollingInterval = useRef(null) // Reference to the interval
  const timeoutRef = useRef(null) // Reference to the timeout

  function toggletab(tab) {
    if (activeTab !== tab) {
      setactiveTab(tab)
    }
  }
  const formatDateToYYYYMMDD = date => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0") // Add 1 to month (0-indexed) and pad with leading zero
    const day = String(date.getDate()).padStart(2, "0") // Pad day with leading zero if necessary
    return `${year}-${month}-${day}`
  }
  const [startDate, setStartDate] = useState(formatDateToYYYYMMDD(new Date()))
  const [endDate, setEndDate] = useState(formatDateToYYYYMMDD(new Date()))

  const fetchpredefinedwords = () => {
    axios
      .get(`${api}/tracker/predefined/keyword`, {})
      .then(res => {
        setpredef(res.data.keywords)
      })
      .catch(error => {
        console.error("Error fetching data:", error)
      })
  }

  useEffect(() => {
    getTrackedApps()
    const firstAppKeywordRawValue = sessionStorage.getItem("firstAppKeyword");
    const firstApp = firstAppKeywordRawValue && firstAppKeywordRawValue !== "undefined" ? JSON.parse(firstAppKeywordRawValue) : null
    setSelectedApp1(firstApp)
    setSelectedAppBasic(JSON.parse(sessionStorage.getItem("countryFlag")))

    setSectionLoading(true)
    fetchCountries()

    trackKeyword(firstApp?.item_id)
    setSelectedApp(
      firstApp?.item_id
    )
    fetchpredefinedwords()
  }, [])

  //to set country n language for the first time
  useEffect(() => {
    const savedCountry = localStorage.getItem("selectedCountryCode")
    const savedLanguage = localStorage.getItem("selectedLanguage")
    const rawCountries = localStorage.getItem("countries");
    const savedCountries = rawCountries ? JSON.parse(rawCountries) : [];

    //const savedCountries = JSON.parse(localStorage.getItem("countries"))

    if (savedCountry) {
      setSelectedCountryCode(savedCountry)
      const countryData = savedCountries.find(c => c.code == savedCountry)

      const langs = countryData ? countryData.locales : []
      setLanguages([...new Set(langs)])

      if (langs.includes(savedLanguage)) {
        setSelectedLanguage(savedLanguage)
      }
    }
  }, [countries])

  useEffect(() => {
    setSectionLoading(true)
    trackKeyword(selectedApp1?.item_id)

    const appdata = alreadyTrackedApps.find(
      app => app.item_id === selectedApp1?.item_id
    )
    setSelectedAppBasic(appdata?.local_details)
    sessionStorage.setItem(
      "conutryFlag",
      JSON.stringify(appdata?.local_details)
    )
  }, [selectedApp1])

  function toggle_modal() {
    setmodal_toggle(!modal_toggle)
  }

  function toggle_modalcsv() {
    setcsvModal_toggle(!csvModal_toggle)
  }
  const handleselectedapp = (keyword, app) => {
    // setLoading(true)
    const appToBeTracked = {
      item_id: app.item_id,
      keyword: keyword

    }
    axios.get(`${api}/tracker/app/${app?.item_id}`, {}).then(res => {
      setSelectedApp1(res.data.details)
      addApp(appToBeTracked)

      const appdata = alreadyTrackedApps?.find(
        app => app.item_id === res.data.details.item_id
      )
      sessionStorage.setItem("firstAppKeyword", JSON.stringify(appdata))
      //adding session element
      sessionStorage.setItem(
        "selectedAppKeyword",
        JSON.stringify(res.data.details)
      )
    })
    getCurrentCountryLanguage(app.item_id)

    trackKeyword(app.item_id)
    // getCurrentCountryLanguage(app.item_id)
    toggle_modal()
  }

  // add keyword b y pressing enter
  const handleKeyDown1 = event => {
    if (event.key === "Enter") {
      setIsAddDisabled(true)
      setKeywordLoading(true)
      setLoading(true)
      //handleSearch() // Call the function when Enter is pressed
      const keywords = inputValue
        .split(",")
        .map(keyword => keyword.trim())
        .filter(keyword => keyword.length > 0)

      // Iterate through each keyword and add to tracked keywords
      keywords.forEach(keyword => {
        if (!trackedKeyword.includes(keyword)) {
          addtoTrackKeywords(selectedApp1.item_id, keyword)
        }
      })

      setInputValue("") // Clear the input field
    }
  }
  async function addtoTrackKeywords(game_id, selectedWord) {
    const gamedata = {
      item_id: game_id,
      keyword: selectedWord,
      country: selectedCountryCode,
      language: selectedLanguage,
    }
    // setLoading(true)
    if (!selectedCountryCode || !selectedLanguage || !selectedWord) {
      setShowValidation(true)
      setIsAddDisabled(false)
      setKeywordLoading(false)
      setLoading(false)
      return // Prevent selection
    }

    try {
      const res = await axios.post(
        `${api}/tracker/tracking/add_category_tracking`,
        gamedata,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          // data: { item_id: gameid, category: selectedCategory }, // Adjust this key if the payload requires a different name
        }
      )
      refreshTrackedApps()
      await trackKeyword(game_id)
    } catch (error) {
      console.error("Error getting data:", error)
    } finally {
      setIsAddDisabled(false)
      setKeywordLoading(false)
      setLoading(false)
    }
  }

  async function trackKeyword(game_id) {

    let loadingData = true
    while (loadingData) {
      try {
        const res = await axios.get(
          `${api}/tracker/tracking/get_category_tracking?item_id=${game_id}&country=${selectedCountryCode}&language=${selectedLanguage}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        )
        const trackedword = res.data?.data || []
        setTrackedKeywordData(prev => ({
          ...prev,
          [game_id]: trackedword,
        }))

        //extracting keywords for individual app
        const extractedKeywords = Object.values(res.data?.data)
          .filter(item => typeof item === "object" && item.keyword) // Filter objects with the keyword property
          .map(item => item.keyword) // Map to keyword values
        setTrackedKeyword(extractedKeywords)
        setTrackedKeyword2(prev => ({
          ...prev,
          [game_id]: extractedKeywords,
        }))

        const hasEmptyHistoricalData = Object.values(res.data?.data).some(
          item =>
            Array.isArray(item?.matching_historical_data) &&
            item.matching_historical_data.length === 0
        )

        //loadingData = hasEmptyHistoricalData
        loading = false
        setIsAddDisabled(false)
        setKeywordLoading(false)
        setLoading(false)
      } catch (error) {
        console.error("Error getting data:", error)
        break
      } finally {
        setLoading(false)
        setSectionLoading(false)
        setDataLoader(false)
      }
    }
  }

  //add keyword by clicking add button
  const handleAddButton = async itemId => {
    try {
      setKeywordLoading(true)
      setLoading(true)
      const keywords = inputValue
        .split(",")
        .map(keyword => keyword.trim())
        .filter(keyword => keyword.length > 0)

      // Iterate through each keyword and add to tracked keywords
      keywords.forEach(keyword => {
        if (!trackedKeyword.includes(keyword)) {
          addtoTrackKeywords(itemId, keyword)
        }
      })
      setInputValue("")
    } catch (error) {
    } finally {
      setIsAddDisabled(false)
    }
  }

  //removing word from keyword array
  const removeItem = async (gameid, word) => {
    setLoading(true)
    const data = { game_id: gameid, entity_type: "keyword", entity_id: word }
    try {
      const res = await axios.post(
        `${api}/tracker/tracking/remove_entity`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          // data: { game_id: gameid, entity_type: "keyword", entity_id: word },
        }
      )
      await trackKeyword(gameid)

    } catch (error) {
      console.error("Error getting data:", error)
    }
  }

  const addApp = async (appData) => {
    setLoading(true)
    //const data = { game_id: gameid, entity_type: "keyword", entity_id: null }
    try {
      const res = await axios.post(
        `${api}/tracker/tracking/add_category_tracking`,
        appData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          // data: { game_id: gameid, entity_type: "keyword", entity_id: word },
        }
      )
      console.log(res)
      await getTrackedApps(1)
    } catch (error) {
      console.error("Error getting data:", error)
    } finally {
      setLoading(false)
    }
  }
  const removeApp = async (gameid, word) => {
    setLoading(true)
    const data = { game_id: gameid, entity_type: "keyword", entity_id: null }
    try {
      const res = await axios.post(
        `${api}/tracker/tracking/remove_entity`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          // data: { game_id: gameid, entity_type: "keyword", entity_id: word },
        }
      )
      await getTrackedApps(1)
    } catch (error) {
      console.error("Error getting data:", error)
    } finally {
      setLoading(false)
    }
  }

  const getTrackedApps = async removed => {
    if (removed) {
      try {
        const res = await axios.get(
          `${api}/tracker/tracking/get_user_tracked_category`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        )
        const apps = res.data?.data?.game_data || []
        setAlreadyTrackedApps(apps)
        const gameData1 = apps?.[0] || null

        setSelectedApp1(gameData1)
        //adding session element
        sessionStorage.setItem("firstAppKeyword", JSON.stringify(gameData1))
        setSelectedCountryCode(gameData1.local_details[0].country)
        setSelectedLanguage(gameData1.local_details[0].language)

      } catch (error) {
        console.error("Error getting data:", error)
      } finally {
        setLoading(false)
      }
    } else {
      const firstAppKeywordRawValue = sessionStorage.getItem("firstAppKeyword");
      const firstApp = firstAppKeywordRawValue && firstAppKeywordRawValue !== "undefined" ? JSON.parse(firstAppKeywordRawValue) : null

      if (firstApp == null) {
        setLoading(true)

        try {
          const res = await axios.get(
            `${api}/tracker/tracking/get_user_tracked_category`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("authToken")}`,
              },
            }
          )
          const apps = res.data?.data?.game_data || []
          setAlreadyTrackedApps(apps)
          sessionStorage.setItem("trackedApps", JSON.stringify(apps))
          const gameData1 = apps?.[0] || null

          setSelectedApp1(gameData1)

          //adding session element
          sessionStorage.setItem("firstAppKeyword", JSON.stringify(gameData1))
          setSelectedCountryCode(gameData1.local_details[0].country)
          setSelectedLanguage(gameData1.local_details[0].language)
        } catch (error) {
          console.error("Error getting data:", error)
        } finally {
          setLoading(false)
        }
      }
    }
  }

  useEffect(() => {
    refreshTrackedApps()
  }, [trackedKeyword])

  const refreshTrackedApps = async () => {
    try {
      const res = await axios.get(
        `${api}/tracker/tracking/get_user_tracked_category`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      )
      const apps = res.data?.data?.game_data || []
      setAlreadyTrackedApps(apps)

      const appdata = apps.find(app => app.item_id === selectedApp1?.item_id)
      setSelectedAppBasic(appdata?.local_details)
      sessionStorage.setItem(
        "conutryFlag",
        JSON.stringify(appdata?.local_details)
      )
    } catch (error) {
      console.error("Error in refresh data:", error)
    }
  }
  const copyTrackedApps = trackedApps => {
    const combinedString = trackedApps.join(", ")

    navigator.clipboard
      .writeText(combinedString)
      .then(() => {
        alert("Copied to clipboard: " + combinedString) // Optional: show confirmation
      })
      .catch(err => {
        console.error("Failed to copy: ", err)
      })
  }

  const fetchCountries = async () => {
    try {
      let res = await axios.get(`${api}/countries`, {})
      setCountries(res.data.data)
      localStorage.setItem("countries", JSON.stringify(res.data.data))
    } catch (error) {
      console.error("Error fetching Countries:", error)
    }
  }

  const handleCountryChange = e => {
    const selected = e.target.value
    setSelectedCountryCode(selected)
    localStorage.setItem("selectedCountryCode", selected)
    const countryData = countries.find(country => country.code === selected)
    //setCCOde(countryData.code)
    const newLang = countryData ? countryData.locales : []

    setLanguages(countryData ? countryData.locales : [])
    if (!newLang.includes(selectedLanguage)) {
      setSelectedLanguage("")
      localStorage.removeItem("selectedLanguage")
    }
  }

  const getCurrentCountryLanguage = item_id => {
    const appdata = alreadyTrackedApps?.find(app => app.item_id === item_id)
    setSelectedLanguage(appdata?.local_details[0]?.language)
    setSelectedCountryCode(appdata?.local_details[0]?.country)

    localStorage.setItem(
      "selectedCountryCode",
      appdata?.local_details[0]?.country
    )
    localStorage.setItem(
      "selectedLanguage",
      appdata?.local_details[0]?.language
    )

    // console.log(
    //   "current data:",
    //   appdata?.local_details[0]?.language,
    //   appdata?.local_details[0]?.country
    // )
  }
  function convertEpochToDate(epochTime) {
    const date = new Date(epochTime * 1000) // Multiply by 1000 to convert from seconds to milliseconds

    const day = String(date.getDate()).padStart(2, "0") // Get day and pad with zero if needed
    const month = String(date.getMonth() + 1).padStart(2, "0") // Get month (0-based, so add 1)
    const year = date.getFullYear().toString().slice(-4) // Get last 2 digits of the year
    const hours = String(date.getHours()).padStart(2, "0") // Get hours
    const minutes = String(date.getMinutes()).padStart(2, "0") // Get minutes

    // Format the date as dd-mm-yy hh:mm
    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`

    return formattedDate
  }
  useEffect(() => {
    const countryData = countries.find(
      country => country.code === selectedCountryCode
    )
    //setCCOde(countryData.code)
    const newLang = countryData ? countryData.locales : []
    setLanguages(countryData ? countryData.locales : [])
    if (!newLang.includes(selectedLanguage)) {
      setSelectedLanguage("")
    }

    setLanguages(newLang)
  }, [selectedCountryCode])

  useEffect(() => {
    setDataLoader(true)
    trackKeyword(selectedApp1?.item_id)
  }, [selectedLanguage, selectedCountryCode])

  const setCountyLanguage = val => {
    setSelectedCountryCode(val.country)
    setSelectedLanguage(val.language)
  }

  const FlagComponent = flags[selectedCountryCode] // dynamically get the flag

  return (
    <React.Fragment>
      <SEO title="Genre Tracking" description="Track category performance and rankings." />
      <div style={{ paddingBottom: 200 }} className="page-content m-3">
        <Row className="ms-3 mb-3"><div


        >
          <div
            style={{

              color: "#FFFFFF",
              position: "relative",
              zIndex: 1,
            }}
          >
            <p
              style={{ fontSize: "40px", fontWeight: "600" }}
            >
              Genre Tracking
            </p>
          </div>


        </div></Row>



        {selectedApp1 ? (
          <>
            <Row className="m-3">

              <CardBody>

                <Row className="mt-2">
                  <div >
                    {selectedApp1 == null ? (
                      <div className="col-md-2">
                        <Card

                          onClick={toggle_modal} // Replace with your click handler
                          style={{
                            border: "none",
                            cursor: "pointer", // Makes the card look clickable
                            transition: "background-color 0.3s ease", // Smooth transition for hover effect
                            minHeight: 80,
                          }}
                        >
                          <CardBody className=" mx-auto">
                            <div
                              className="d-flex gap-2 my-auto mb-2"
                              style={{ minHeight: 180 }}
                            >
                              <FaCirclePlus size={20} className="my-auto" />
                              <p className="my-auto">
                                <b>Select game</b>
                              </p>
                            </div>
                          </CardBody>
                        </Card>
                      </div>
                    ) : (

                      <Row className="g-0 align-items-center flex-nowrap" style={{ overflow: 'hidden' }}>
                        {/* Left: Image */}
                        <Col xs="auto">
                          <Link
                            to={`/xr/app/${generateSlug(selectedApp1?.name || '')}?id=${selectedApp1?.item_id}`}
                            state={{
                              app_id: selectedApp1?.item_id,
                              data: selectedApp1,
                            }}
                          >
                            <CardImg
                              src={selectedApp1?.image_url || "https://via.placeholder.com/50"}
                              alt="image cap"
                              style={{
                                height: 400,
                                width: 620,
                                objectFit: "cover",
                              }}
                              className="m-2"
                            />
                          </Link>
                        </Col>

                        {/* Middle: Info */}
                        <Col style={{ minWidth: 0, padding: '4.75rem' }}>
                          <CardBody className="p-2 text-truncate">
                            <p
                              style={{ fontSize: "32px", fontWeight: "600" }}
                            >
                              {selectedApp1?.name || "Demo1"}
                            </p>



                            <div className="d-flex flex-wrap gap-2 text-truncate ">
                              <a
                                href={selectedApp1?.website_url}
                                target="_blank"
                                rel="noopener noreferrer"

                              >



                              </a>
                              <Link to={`/publisher-apps/${selectedApp1?.item_id}`}>
                                <p className="mb-0 text-truncate">
                                </p>
                              </Link>
                            </div>

                            <span style={{ color: "#FFFFFF", fontSize: "32px" }}> <span style={{ color: "#E8E8E8", fontSize: "32px", }}>Publisher: </span>{selectedApp1?.publisher || "publisher"}</span>
                            <div className="d-flex align-items-center gap-2 mt-2">
                              <span style={{ color: "#FFFFFF", fontSize: "32px" }}>
                                <span style={{ color: "#E8E8E8", fontSize: "32px", }}> Category :  </span>{selectedApp1?.category || "category"}
                              </span>
                            </div>
                            <div className="d-flex align-items-center gap-2 mt-2">

                              <small className="text-muted"> <span style={{ color: "#FFFFFF", fontSize: "32px" }}><span style={{ color: "#E8E8E8,fontSize: 32px" }}>Updated : </span> Last updated 3 mins ago</span></small>
                            </div>
                          </CardBody>
                        </Col>

                        {/* Right: Buttons */}
                        <Col xs="auto">
                          <div className="d-flex flex-column align-items-center justify-content-center gap-2 p-3">
                            <Button
                              className="w-100 pink-btn "
                              style={{

                                fontSize: "32px"
                              }}
                              onClick={() => {
                                addApp(selectedApp1);
                                toggle_modal();
                              }}
                            >
                              Select Another App
                            </Button>
                            <div className="d-flex justify-content-end w-100">
                              <Button
                                className="grey-remove-btn"
                                onClick={() => removeApp(selectedApp1?.item_id)}
                                style={{
                                  borderRadius: "12px",
                                  margin: 0,
                                  width: "220px", // Or maxWidth: "140px"
                                  fontSize: "32px"
                                }}
                              >
                                Remove App
                              </Button>
                            </div>
                          </div>
                        </Col>
                      </Row>

                    )}
                  </div>
                </Row>


              </CardBody>

            </Row>


            {sectionLoading ? (
              <>
                <Row className="mt-4">
                  <div className="d-flex justify-content-center">
                    <Spinner size="lg" color="primary" />
                  </div>
                </Row>
              </>
            ) : (
              <>
                <Row className="m-3">

                  <CardBody>
                    <Row>
                      <div className="d-flex flex-wrap align-items-center gap-2 mt-3">
                        <label
                          style={{ fontSize: "32px", fontWeight: "600", color: "white" }}
                        >
                          Tracked Data Availability
                        </label>


                      </div>
                    </Row>
                    <Row className="mt-3">
                      <div className="d-flex justify-content-start gap-4">
                        <Col md={3}>
                          <div className="d-flex justify-content-start align-items-center gap-2">
                            <label className="mb-0" style={{ fontSize: "30px" }}>Country</label>
                            <select
                              id="country"
                              value={selectedCountryCode}
                              className="form-control"
                              style={{ fontSize: "30px" }}
                              onChange={handleCountryChange}
                            >
                              <option value="">-- Select a Country --</option>
                              {countries?.map(country => {
                                return (
                                  <option
                                    key={country.code}
                                    value={country.code}
                                  >
                                    {country.name} ({country.code})
                                  </option>
                                )
                              })}
                            </select>

                          </div>
                          {showValidation && !selectedCountryCode && (
                            <span className="text-danger">
                              Country is required.
                            </span>
                          )}
                        </Col>

                        <Col md={3}>
                          <div className="d-flex justify-content-start align-items-center gap-2">
                            <label className="mb-0" style={{ fontSize: "24px" }}>Language</label>
                            <select
                              id="language"
                              value={selectedLanguage}
                              className="form-control"
                              style={{ fontSize: "30px" }}
                              onChange={e => {
                                setSelectedLanguage(e.target.value)
                                localStorage.setItem(
                                  "selectedLanguage",
                                  e.target.value
                                )
                              }}
                              // onChange={handleLanguageChange}
                              disabled={!selectedCountryCode}
                            >
                              <option value="">-- Select Language --</option>
                              {languages.map(lang => (
                                <option key={lang} value={lang}>
                                  {lang}
                                </option>
                              ))}
                            </select>
                          </div>
                          {showValidation && !selectedLanguage && (
                            <span className="text-danger">
                              Language is required.
                            </span>
                          )}
                        </Col>
                      </div>
                    </Row>
                  </CardBody>

                </Row>
                {dataLoader ? (
                  <>
                    <Row className="mt-4">
                      <div className="d-flex justify-content-center">
                        <Spinner size="lg" color="primary" />
                      </div>
                    </Row>
                  </>
                ) : (
                  <>
                    <Row className="m-3">

                      <CardBody>
                        <CardTitle style={{ fontSize: "32px", fontWeight: "600" }}>
                          Keyword Section
                        </CardTitle>

                        {/* <Row className="mb-3">
                        <div className="d-flex justify-content-start gap-1">
                          <Col md={3}>
                            <select
                              id="country"
                              value={selectedCountryCode}
                              className="form-control"
                              onChange={handleCountryChange}
                            >
                              <option value="">-- Select a Country --</option>
                              {countries.map(country => (
                                <option key={country.code} value={country.code}>
                                  {country.name} ({country.code})
                                </option>
                              ))}
                            </select>
                            {showValidation && !selectedCountryCode && (
                              <span className="text-danger">
                                Country is required.
                              </span>
                            )}
                          </Col>

                          <Col md={3}>
                            <select
                              id="language"
                              value={selectedLanguage}
                              className="form-control"
                              onChange={e => {
                                setSelectedLanguage(e.target.value)
                                localStorage.setItem(
                                  "selectedLanguage",
                                  e.target.value
                                )
                              }}
                              // onChange={handleLanguageChange}
                              disabled={!selectedCountryCode}
                            >
                              <option value="">-- Select Language --</option>
                              {languages.map(lang => (
                                <option key={lang} value={lang}>
                                  {lang}
                                </option>
                              ))}
                            </select>
                            {showValidation && !selectedLanguage && (
                              <span className="text-danger">
                                Language is required.
                              </span>
                            )}
                          </Col>
                        </div>
                      </Row> */}

                        <div className="d-flex flex-wrap gap-2 mt-3">
                          {predefKeyword.map((value, index) => {
                            return (
                              <Button
                                key={index}
                                color="dark"
                                className="btnparent btn-rounded"
                                style={{ fontSize: "30px" }}
                                onClick={() => {
                                  setIsAddDisabled(true)
                                  setKeywordLoading(true)
                                  setLoading(true)
                                  //console.log(`selected word:${value}`)

                                  if (
                                    !trackedKeyword.includes(value.trim())
                                  ) {
                                    // setTrackedKeyword(prevItems => [
                                    //   ...prevItems,
                                    //   value.trim(),
                                    // ])
                                  }
                                  addtoTrackKeywords(
                                    selectedApp1.item_id,
                                    value
                                  )
                                }}
                              >
                                <div className="keywordbtn">{value}</div>
                              </Button>
                            )
                          })}
                        </div>

                        <Row className="mb-4 mt-5 align-items-center">
                          <Col sm={6}>
                            <div className="input-group">
                              <span
                                className="input-group-text bg-dark text-white"
                                style={{
                                  borderradius: "10px",
                                  borderBottomLeftRadius: "10px",
                                  fontSize: "28px", // increases icon size
                                  padding: "0 20px", // optional: more spacing around the icon
                                }}
                              >
                                <i className="uil uil-search" />
                              </span>

                              <Input
                                type="text"
                                disabled={isAddDisabled}
                                className="form-control"
                                id="horizontal-firstname-input"
                                placeholder="Enter the keyword"
                                value={inputValue}
                                onChange={e => setInputValue(e.target.value)}
                                onKeyDown={handleKeyDown1}
                                style={{
                                  height: "65px",
                                  fontSize: "30px",
                                  borderTopRightRadius: "10px",
                                  borderBottomRightRadius: "10px",
                                  padding: "0 20px",
                                }}
                              />
                            </div>

                          </Col>

                          <Col sm={2}>
                            <Button
                              className="pink-btn"
                              disabled={isAddDisabled}
                              style={{
                                height: "70px",
                                fontSize: "30px",
                                fontWeight: "600",
                                padding: "0 60px" // increases width via internal spacing
                              }}
                              onClick={() => {
                                setIsAddDisabled(true);
                                handleAddButton(selectedApp1.item_id);
                              }}
                            >
                              {keywordLoading ? <Spinner size="sm" color="white" /> : "Search"}
                            </Button>
                          </Col>

                          <Col sm={2}>
                            <Button
                              color="secondary"
                              style={{ height: "58px", fontSize: "30px" }} // match height
                              onClick={() => {
                                copyTrackedApps(trackedKeyword2[selectedApp1.item_id] || []);
                              }}
                            >
                              Copy Apps
                            </Button>
                          </Col>
                        </Row>

                        <Row>
                          <Col sm={2}></Col>
                          <Col sm={6}>
                            <p>
                              For bulk upload, separate by commas like:
                              "subway,vr shooter,vr football"
                            </p>
                          </Col>
                          <Col sm={2}></Col>
                        </Row>

                        <Row className="mt-3">
                          <CollapsibleTrackedWords
                            trackedKeyword={trackedKeyword2}
                            selectedApp={selectedApp1}
                            removeItem={removeItem}
                          ></CollapsibleTrackedWords>
                        </Row>
                      </CardBody>

                    </Row>

                    <Row className="m-3">
                      <div className="d-flex flex-wrap justify-content-between">
                        <div className="d-flex flex-wrap gap-4">
                          <label
                            htmlFor="example-date-input"
                            className="col-form-label"
                            style={{ fontSize: "30px" }}
                          >
                            From
                          </label>
                          <div className="">
                            <input
                              className="form-control"
                              style={{ fontSize: "30px" }}
                              type="date"
                              defaultValue={startDate}
                              max={new Date().toISOString().split("T")[0]}
                              onChange={e => {
                                setStartDate(e.target.value)
                                setSwitchTable(true)
                              }}
                              id="example-date-input"
                            />
                          </div>
                        </div>

                        <div className="d-flex flex-wrap gap-4">
                          <label
                            htmlFor="example-date-input"
                            className="col-form-label"
                            style={{ fontSize: "30px" }}
                          >
                            To
                          </label>
                          <div className="">
                            <input
                              className="form-control"
                              style={{ fontSize: "30px" }}
                              type="date"
                              defaultValue={endDate}
                              max={new Date().toISOString().split("T")[0]}
                              onChange={e => {
                                setEndDate(e.target.value)
                                setSwitchTable(true)
                              }}
                              id="example-date-input"
                            />
                          </div>
                        </div>
                      </div>
                    </Row>
                    <Row className="m-3">
                      {trackedKeywordData[selectedApp1.item_id] && (

                        <DataGraphTable
                          keywordData={trackedKeywordData[selectedApp1.item_id]}
                        ></DataGraphTable>
                      )}
                      <Button
                        className="pink-btn w-auto mt-2"
                        style={{
                          height: "70px",        // already set height
                          fontSize: "30px",      // increased font size
                          fontWeight: "600",
                          padding: "0 60px"     // optional: makes the text bolder
                        }}
                        onClick={() => {
                          setSelectedApp(selectedApp1?.item_id)
                          toggle_modalcsv()
                          // getCsv()
                        }}
                      >
                        Get CSV
                      </Button>
                    </Row>

                  </>
                )}
              </>
            )}
          </>
        ) : (
          <>
            <Row className="m-3">
              <Card className="">
                <CardBody>
                  <Row className="mt-3">
                    <div className="d-flex justify-content-between"></div>
                  </Row>
                  <Row className="mt-2">
                    <div className="d-flex flex-wrap gap-2 justify-content-center">
                      <div className="col-md-2">
                        <Card
                          className="app-card-container2  border border-1 rounded"
                          onClick={toggle_modal} // Replace with your click handler
                          style={{
                            border: "none",
                            cursor: "pointer", // Makes the card look clickable
                            transition: "background-color 0.3s ease", // Smooth transition for hover effect
                            minHeight: 80,
                          }}
                        >
                          <CardBody className=" mx-auto">
                            <div
                              className="d-flex gap-2 my-auto mb-2"
                              style={{ minHeight: 180 }}
                            >
                              <FaCirclePlus size={20} className="my-auto" />
                              <p className="my-auto">
                                <b>Select game</b>
                              </p>
                            </div>
                          </CardBody>
                        </Card>
                      </div>
                    </div>
                  </Row>
                </CardBody>
              </Card>
            </Row>
          </>
        )}
      </div>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
          }}
        >
          <Spinner size="lg" color="primary" />
        </div>
      )}
      <AppSearchModal
        modaltoggle={modal_toggle}
        togglemodal={toggle_modal}
        onAppSelect={handleselectedapp}
        alreadySelectedApps={alreadyTrackedApps}
        type="Keyword"
      ></AppSearchModal>
      <GetCSVModal
        modaltoggle={csvModal_toggle}
        togglemodal={toggle_modalcsv}
        gameId={selectedApp}
        dataType="keyword"
      ></GetCSVModal>
    </React.Fragment>
  )
}
